import React from 'react';
import { Mountain } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-16 pb-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto flex flex-col items-center text-center" data-id="element-59">
      {/* Background subtle elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-4xl opacity-5 pointer-events-none flex justify-center items-start pt-20" data-id="element-60">
        <Mountain size={400} data-id="element-61" />
      </div>

      <div className="relative z-10 flex flex-col items-center" data-id="element-62">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-trek-orange/10 border border-trek-orange/30 text-trek-orange font-semibold text-sm tracking-wide mb-8" data-id="element-63">
          <span className="w-2 h-2 rounded-full bg-trek-orange animate-pulse" data-id="element-64"></span>
          EXCLUSIVO PARA TREKKERS
        </div>

        <h1 className="text-2xl sm:text-3xl md:text-4xl font-display text-white leading-[1.2] mb-8 max-w-3xl" data-id="element-65">
          Pasá de caminatas simples a rutas más exigentes con{' '}
          <span className="text-trek-orange" data-id="element-66">Pack Trekking PRO</span>
        </h1>

        <a href="#comprar" className="relative w-[80%] max-w-3xl mb-10 group block" aria-label="Ver Pack Trekking Pro" data-id="element-67">
          <div className="absolute -inset-1 bg-gradient-to-r from-trek-orange to-trek-brown rounded-2xl blur opacity-25 group-hover:opacity-40 transition duration-1000 group-hover:duration-200" data-id="element-68"></div>
          <img src="https://cdn.magicpatterns.com/uploads/6bdDKpnDcs2rqHwLuDzu4g/ChatGPT_Image_May_9__2026__07_09_11_PM-removebg-preview.png" alt="Pack Trekking Pro" className="relative w-full object-contain transition-transform group-hover:scale-[1.02]" data-id="element-69" />
        </a>

        <p className="text-lg sm:text-xl text-trek-beige max-w-3xl mb-10 leading-relaxed" data-id="element-70">
          Una guía con recursos teóricos, prácticos y sencillos para aficionados
          y amantes del trekking.
        </p>

        <a href="#comprar" className="inline-flex items-center justify-center px-8 py-5 text-xl font-display bg-trek-orange hover:bg-trek-orangeLight text-white rounded-xl transition-all transform hover:scale-105 hover:shadow-[0_0_30px_rgba(224,122,44,0.4)] w-full sm:w-auto" data-id="element-71">
          ⛰️ QUIERO MI PACK TREKKING PRO →
        </a>
      </div>
    </section>;
}